import { apiClient } from '../api-client'
import { Discussion, DiscussionAttachment, DiscussionSummary } from '@/types'

// Discussions API
export const discussionsApi = {
  getDiscussions: (taskId: string, filters?: any): Promise<Discussion[]> =>
    apiClient.get(`/discussions/task/${taskId}`, { params: filters }),

  getDiscussion: (discussionId: string): Promise<Discussion> =>
    apiClient.get(`/discussions/${discussionId}`),

  createDiscussion: (taskId: string, data: { content: string; parent_discussion_id?: string; attachments?: File[] }): Promise<Discussion> => {
    const formData = new FormData()
    formData.append('content', data.content)
    if (data.parent_discussion_id) {
      formData.append('parent_discussion_id', data.parent_discussion_id)
    }
    if (data.attachments) {
      data.attachments.forEach(file => formData.append('attachments', file))
    }
    return apiClient.post(`/discussions/task/${taskId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  updateDiscussion: (discussionId: string, data: { content: string }): Promise<Discussion> =>
    apiClient.put(`/discussions/${discussionId}`, data),

  deleteDiscussion: (discussionId: string): Promise<void> =>
    apiClient.delete(`/discussions/${discussionId}`),

  getDiscussionSummary: (taskId: string): Promise<DiscussionSummary> =>
    apiClient.get(`/discussions/task/${taskId}/summary`),

  addAttachment: (discussionId: string, file: File): Promise<DiscussionAttachment> =>
    apiClient.post(`/discussions/${discussionId}/attachments`, { file }, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  getAttachments: (discussionId: string): Promise<DiscussionAttachment[]> =>
    apiClient.get(`/discussions/${discussionId}/attachments`),
}